import { combineReducers } from "redux";
import { authReducer } from "./authReducers";
import { profileReducer, profileListReducer } from "./profileReducers";
import localeReducer from "./localeReducers";
import siteReducer from "./siteReducers";
import alertReducer from "./alertReducers";
import {
  patternListReducer,
  patternReducer,
  patternReviewReducer,
  allPatternsReducer,
} from "./patternReducers";
import { cartReducer, favouritesReducer, paymentReducer } from "./cartReducers";
import {
  orderCreateReducer,
  orderDetailsReducer,
  orderPayReducer,
  orderListReducer,
} from "./orderReducers";
import {
  userDeleteReducer,
  userDetailsReducer,
  userListReducer,
  userUpdateReducer,
} from "./userReducer";
import { promoReducer } from "./promoReducers";

export default combineReducers({
  alert: alertReducer,
  auth: authReducer,
  cart: cartReducer,
  favourites: favouritesReducer,
  locale: localeReducer,
  order: orderCreateReducer,
  orderDetails: orderDetailsReducer,
  orderList: orderListReducer,
  orderPay: orderPayReducer,
  pattern: patternReducer,
  patternList: patternListReducer,
  allPatterns: allPatternsReducer,
  patternReview: patternReviewReducer,
  payment: paymentReducer,
  profile: profileReducer,
  profileList: profileListReducer,
  site: siteReducer,
  userList: userListReducer,
  userDelete: userDeleteReducer,
  userDetails: userDetailsReducer,
  userUpdate: userUpdateReducer,
  promo: promoReducer,
});
